import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map, List } from 'immutable';

import FraudAndCompliances from './FraudAndCompliances';
import { FraudAndComliancesTabWrapper } from './FraudAndCompliancesTab.style';

class FraudAndCompliancesTab extends React.Component {
    static propTypes = {
        userId: PropTypes.number,
        user: ImmutablePropTypes.map,
        list: ImmutablePropTypes.list,
        customers: ImmutablePropTypes.map,
        status: PropTypes.string,

        onLoadRequest: PropTypes.func.isRequired,
        onAssignRequest: PropTypes.func.isRequired,
        onUnassignRequest: PropTypes.func.isRequired,
        onOpenAccountRequest: PropTypes.func.isRequired,
        onCancelRequest: PropTypes.func.isRequired,
        dataTest: PropTypes.string
    };

    static defaultProps = {
        list: List(),
        items: Map(),
        customers: Map(),
        status: ''
    };

    constructor(props, context) {
        super(props, context);

        this.state = this.getState(props);
    }

    UNSAFE_componentWillMount() {
        const { onLoadRequest } = this.props;

        onLoadRequest();
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState(this.getState(props));
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            this.props.onLoadRequest(true);
        }, 10000);

        this.setState({ intervalId: intervalId });
    }


    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }


    refreshEvents() {
        this.props.onLoadRequest();
    }

    getState(props) {
        const items = props.items;
        return {
            your: items && items.filter(f => f.getIn([ 'assignee', 'id' ]) === props.userId),
            none: items && items.filter(f => !f.getIn([ 'assignee', 'id' ])),
            other: items && items.filter(f => {
                const assigneeId = f.getIn([ 'assignee', 'id' ]);
                return assigneeId && assigneeId !== props.userId;
            })
        };
    }

    render() {
        const { customers, status,
            onAssignRequest, onUnassignRequest, onOpenAccountRequest, onCancelRequest, title, entityKey, dataTest, manualAv } = this.props;
        const { your, none, other } = this.state;
        return (
            <FraudAndComliancesTabWrapper className='fraud-and-compliances-tab' data-test={dataTest}>
                {title ? <h1 key='fraud-and-compliances-h1' data-test='main-header'> {title} </h1> : null}
                <div className='refreshResults' data-test='refresh-button'>
                    <a href='#' className='btn' onClick={ (e) => {
                        e.preventDefault();
                        this.refreshEvents();
                    }}>
                        Refresh
                    </a>
                </div>

                <FraudAndCompliances
                    key='fraud-and-compliances-your'
                    entityKey={ [ entityKey ] }
                    title={title}
                    data={ your }
                    customers={ customers }
                    status={ status }
                    header='Assigned To You'
                    className='assigned-to-you fraud-and-compliance'
                    type='your'
                    onAssignRequest={ onAssignRequest }
                    onUnassignRequest={ onUnassignRequest }
                    onOpenAccountRequest={ onOpenAccountRequest }
                    onCancelRequest={ onCancelRequest }
                    manualAv={manualAv}
                    dataTest={`${entityKey}-assigned-to-you`}

                />
                <FraudAndCompliances
                    key='fraud-and-compliances-none'
                    entityKey={ [ entityKey ] }
                    title={title}
                    data={ none }
                    customers={ customers }
                    status={ status }
                    header='Pending Requests'
                    className='pending fraud-and-compliance'
                    type='none'
                    onAssignRequest={ onAssignRequest }
                    onUnassignRequest={ onUnassignRequest }
                    onOpenAccountRequest={ onOpenAccountRequest }
                    onCancelRequest={ onCancelRequest }
                    manualAv={manualAv}
                    dataTest={`${entityKey}-pending-requests`}
                />
                <FraudAndCompliances
                    key='fraud-and-compliances-other'
                    entityKey={ [ entityKey ] }
                    title={title}
                    data={ other }
                    customers={ customers }
                    status={ status }
                    header='Assigned To Others'
                    className='assigned-to-others fraud-and-compliance'
                    type='other'
                    onAssignRequest={ onAssignRequest }
                    onUnassignRequest={ onUnassignRequest }
                    onOpenAccountRequest={ onOpenAccountRequest }
                    onCancelRequest={ onCancelRequest }
                    manualAv={manualAv}
                    dataTest={`${entityKey}-assigned-to-others`}
                />
            </FraudAndComliancesTabWrapper>
        );
    }
}

export default FraudAndCompliancesTab;
